import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import PageDashboard from '@/pages/account/dashboard'

export const Route = createFileRoute('/app/account/dashboard')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <PageDashboard />
}
